/*
 * @Description: utils
 * @Author: 山淑兰
 * @Date: 2019-12-19 22:43:47
 * @LastEditTime : 2019-12-19 22:47:36
 * @LastEditors  : 山淑兰
 */
export default {
  /**
   * @description: 返回各类状态码
   * @param {obj} type url:需要跳转的路由
   * @param {obj} type params:tourl
   */
  redirect(url, params) {
    try {
      const { _VUE } = window
      const { query, path } = _VUE.$route

      if (path !== url) {
        _VUE.$router.push({ path: url, query: Object.assign(query, params) })
      }
    } catch (error) {
      console.error(error)
    }
  }
}
